/**
 * Created by m.igrachev on 6/19/2017.
 */
const documentedProperties = [
    {
        name: "children",
        type: "React.Children",
        defaultValue: "n/a",
        isRequired: "true",
        description:
            "Modal component nests ModalHeader, ModalBody and ModalFooter, so some children are expected."
    },
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Extra css classes to be added to Modal."
    },
    {
        name: "visible",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true shows the modal."
    },
    {
        name: "size",
        type: "String",
        defaultValue: "'medium'",
        isRequired: "['small', 'medium', 'large']",
        description: "Determines the size of the modal."
    },
    {
        name: "closeOnSubmit",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true modal will be closed right after submit."
    },
    {
        name: "onSubmit",
        type: "Function",
        defaultValue: "n/a",
        isRequired: "false",
        description: "A callback function to be invoked when the modal is being submitted."
    },
    {
        name: "onClose",
        type: "Function",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "A callback function to be invoked when the modal is being closed with cancel action."
    },
    {
        name: "skipModalMarkup",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description:
            "If set to true it will render a different markup. Markup without a panel and grid container. Use this in cases like when rendering the modal from a GlobalLoading component."
    },
    {
        name: "bodyPortal",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "If set to true, the modal markup will be rendered directly in document.body."
    },
    {
        name: "containerWidth",
        type: "Number",
        defaultValue: "n/a",
        isRequired: "false",
        description: 'Determines the width of the modal in percentages. Overrides "size" property.'
    },
    {
        name: "disablePageScroll",
        type: "Boolean",
        defaultValue: false,
        isRequired: false,
        description:
            "If set to true will remove the document scroll for the time that the modal is opened."
    }
];

export default documentedProperties;
